export default __webpack_public_path__ + "static/media/TeachMachines.9dcbae50.png";